module.exports = __webpack_public_path__ + "static/media/delete-warning.df190def.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/delete-warning.svg
// module id = 124
// module chunks = 0